export const Claims = {
  AdminDataSkillExtractionView: "admin.data.skillextraction.view",
  AdminDataSkillExtractionImport: "admin.data.skillextraction.import",
  AdminDataSkillExtractionExport: "admin.data.skillextraction.export",
  AdminDataSkillExtractionUpload: "admin.data.skillextraction.upload",
  AdminBenchmarkSkillsView:"admin.benchmark.skills.view",
  AdminBenchmarkMicroSkillsView:"admin.benchmark.microskills.view",
  AdminBenchmarkJFAView:"admin.benchmark.jfa.view",
  AdminBenchmarkSkillsImport: "admin.benchmark.skills.import",
  AdminBenchmarkMicroSkillsImport: "admin.benchmark.microskills.import",
  AdminBenchmarkJFAImport: "admin.benchmark.jfa.import",
  AdminBenchmarkSkillsExport: "admin.benchmark.skills.export",
  AdminBenchmarkMicroSkillsExport: "admin.benchmark.microskills.export",
  AdminBenchmarkJFAExport: "admin.benchmark.jfa.export",
  AdminBenchmarkSkillsUpload: "admin.benchmark.skills.upload",
  AdminBenchmarkMicroSkillsUpload: "admin.benchmark.microskills.upload",
  AdminBenchmarkJFAUpload: "admin.benchmark.jfa.upload",
};
